import {Pipe, PipeTransform} from '@angular/core';
import {TranslationValue} from '../../generated/sales-terminal-client';
import {LanguageService} from '../../services/language/language.service';
import {AuthService} from '../../services/auth/auth.service';
import {TranslateService} from '@ngx-translate/core';
import {cloneDeep} from 'lodash-es';

@Pipe({
  name: 'translateValue',
  pure: false
})
export class TranslateValuePipe implements PipeTransform {
  constructor(private languageService: LanguageService,
              private authService: AuthService,
              private translateService: TranslateService) {}

  transform(values: TranslationValue[] | string | number, hideAny: boolean = false, allowedLanguages?: string[]): string {
    if (!values) {
      return '';
    }
    if (typeof values === 'number') {
      values = values.toString();
    }
    if (typeof values === 'string') {
      return this.translateService.instant(values);
    }
    let curatedValues: TranslationValue[] = cloneDeep(values);
    if (allowedLanguages?.length) {
      curatedValues = curatedValues.filter(value => allowedLanguages.includes(value.language));
    }
    const key: string = curatedValues.find(translation => translation.language === this.languageService.selectedLang)?.value ||
      curatedValues.find(translation => translation.language === this.authService.salesPointLanguage)?.value ||
      (!hideAny && curatedValues?.length ? curatedValues[0]?.value : '');
    return key ? this.translateService.instant(key) : '';
  }
}
